import { Component } from 'react'
import styled, { css } from 'styled-components'

import { SmallGradientOffsetCard } from 'bl-common/src/cards/SmallGradientOffsetCard/SmallGradientOffsetCard'
import { Type } from 'bl-common/src/elements/Typography/Typography'
import { media } from 'bl-common/src/utils/media'

type RelatedProps = {
  heading?: string
  textContent?: any
  textContentSide?: string
  cards?: any
}

type HalfProps = {
  order?: number
}

type TextHalfProps = {
  order?: number
}

type CardContentProps = {
  textContentSide?: any
}

const Container = styled.div`
  padding-bottom: 32px;
  padding-top: 16px;

  ${media.md(css`
    display: flex;
    padding-top: ${({ theme }) => theme.spacing[4]};
    padding-bottom: ${({ theme }) => theme.spacing[4]};
  `)}
`

const CardContainer = styled.div`
  display: flex;
  max-width: 400px;
  width: 100%;
`

const Half = styled.div<HalfProps>`
  ${({ order }) => css`
    order: ${order};
  `};
`

const TextHalf = styled(Half)<TextHalfProps>`
  flex: 1;
  ${({ order }) =>
    order === 1
      ? media.md(css`
          > * {
            margin-right: auto;
          }
        `)
      : media.md(css`
          > * {
            margin-right: auto;
          }
        `)};
`

const CardHalf = styled(Half)`
  display: flex;
  position: relative;

  ${media.md(css`
    margin: 0 ${({ theme }) => theme.spacing[5]};
  `)}

  ${({ order }) =>
    order === 1
      ? media.md(css`
          flex: 1;
          > * {
            justify-content: flex-start;
          }
          ${CardContainer} {
            margin-left: auto;
          }
        `)
      : media.md(css`
          flex: 0 1 auto;
          margin-left: 0;
          > * {
            justify-content: flex-end;
          }
        `)};
`

const CardContent = styled.div<CardContentProps>`
  flex: 0 1 100%;
  position: relative;
  width: 100%;
`

const Card = ({ textContentSide, fields }) => (
  <CardContent textContentSide={textContentSide}>
    <SmallGradientOffsetCard layout="Landscape" {...fields} />
  </CardContent>
)

export class Related extends Component<RelatedProps> {
  render() {
    const { heading, textContent, textContentSide = 'left', cards } = this.props

    return (
      <Container>
        <TextHalf order={textContentSide === 'left' ? 0 : 1}>
          <Type
            as="h2"
            size={{ xs: 20, md: 40 }}
            weight="bold"
            bottom={{ xs: 1.5, md: 2 }}
            top={{ xs: 3, md: 1 }}
            maxWidth={480}
          >
            {heading}
          </Type>
          <Type
            preset="subtitle"
            multiline
            maxWidth={480}
            bottom={{ xs: 3, md: 1 }}
          >
            {textContent}
          </Type>
        </TextHalf>
        <CardHalf order={textContentSide === 'right' ? 0 : 1}>
          <CardContainer>
            {cards?.map(({ fields }) => (
              <Card
                key={fields.title}
                fields={fields}
                textContentSide={textContentSide}
              />
            ))}
          </CardContainer>
        </CardHalf>
      </Container>
    )
  }
}

export default Related
